(function() {
  document.addEventListener('DOMContentLoaded', function() { // Wait until DOM is fully loaded
    const buttons = document.querySelectorAll(".collection__view-all .button, .banner__buttons .button");

    buttons.forEach(button => {
      // Create <span> dynamically if missing
      if (!button.querySelector('span')) {
        const span = document.createElement('span');
        button.appendChild(span);
      }

      const span = button.querySelector('span');

      button.addEventListener('mouseenter', function(e) {
        const rect = button.getBoundingClientRect();
        const relX = e.clientX - rect.left;
        const relY = e.clientY - rect.top;

        span.style.top = relY + "px";
        span.style.left = relX + "px";
      });

      button.addEventListener('mouseout', function(e) {
        const rect = button.getBoundingClientRect();
        const relX = e.clientX - rect.left;
        const relY = e.clientY - rect.top;

        span.style.top = relY + "px";
        span.style.left = relX + "px";
      });
    });
  });
})();
